var map = {
	"./Conneightion.png": 360,
	"./TRI.png": 361,
	"./Telangana.PNG": 362,
	"./airtel.png": 363,
	"./ap.png": 364,
	"./bgm.png": 365,
	"./butterfly.png": 366,
	"./crown.png": 367,
	"./da.png": 368,
	"./dell.png": 369,
	"./dm.png": 370,
	"./dorvenfoods.png": 371,
	"./dorvenretail.png": 372,
	"./dytronix.png": 373,
	"./fb.png": 374,
	"./fc.png": 375,
	"./feedbellie.png": 376,
	"./ffas.png": 377,
	"./ghmc.png": 378,
	"./goa.png": 379,
	"./hp.png": 380,
	"./hsf.png": 381,
	"./janahitha.png": 382,
	"./jbl.png": 383,
	"./jd.png": 384,
	"./jdesk.png": 385,
	"./jds.png": 386,
	"./kamlesh.png": 387,
	"./kdrav.png": 388,
	"./kdrf.png": 389,
	"./kdrm.png": 390,
	"./klubf5.png": 391,
	"./leafent.png": 392,
	"./mananagaram.png": 393,
	"./manymore.png": 394,
	"./nalgonda.png": 395,
	"./nbb.png": 396,
	"./nowl.png": 397,
	"./paw.png": 398,
	"./rsd.png": 399,
	"./santos.png": 400,
	"./shikara.png": 401,
	"./srpt.png": 402,
	"./startcareer.png": 403,
	"./sunrisers.png": 404,
	"./svmovie.png": 405,
	"./talasha.png": 406,
	"./teeksha.png": 407,
	"./tfs.png": 408,
	"./ting.png": 409,
	"./tsforest.png": 410,
	"./turtle.png": 411,
	"./vanamali.png": 412,
	"./veehaari.png": 413,
	"./vertisoft.png": 414,
	"./vh.png": 415,
	"./vhcabs.png": 416,
	"./vikram.png": 417,
	"./wa.png": 418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 598;